import { render, staticRenderFns } from "./PaymentsHelp.vue?vue&type=template&id=6f1edaa4"
import script from "./PaymentsHelp.vue?vue&type=script&lang=js"
export * from "./PaymentsHelp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../frontAgencies/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports